import { DateTime } from "luxon"
import { IDatePeriod } from "../../../../components/datePeriodPicker/datePeriodPicker"
import BaseDocumentCreator from "../../../../components/documents/baseDocumentCreator"
import { DatePeriodPanel } from "../../../../hoc/DatePeriodPanel/DatePeriodPanel"
import { useTabsContext } from "../../../../system/providers/tabsProvider"
import { useEffect, useState } from "react"
import GridSelectorInput from "../../../../components/controls/GridSelectorInput"
import AccessPointSelectorModal from "../../../Service/AccessPoint/AccessPointSelectorModal"
import StoreSelectorModal from "../../../Dictionaries/Store/StoreSelectorModal"
import ContractorSelectorModal from "../../../Dictionaries/Contractor/ContractorSelectorModal"
import { Accordion } from "../../../../components/controls/accordion"
import { v4 as uuidv4 } from "uuid";
import { CheckBox } from "../../../../components/controls/checkbox"
import FlexColumn from "../../../../components/controls/FlexColumn"
import FlexRow from "../../../../components/controls/FlexRow"
import { IOption, Select } from "../../../../components/selects/select"
import { IExport1CViewDto } from "../../../../libs/coreapi-dto/service/export1C"
import { useAppContext } from "../../../../system/providers/appContextProvider"
import { Export1CDataProvider } from "../../../../Services/DataProviders/Export1CDataProvider"
import { IEntitySimpleDTO } from "../../../../libs/coreapi-dto/@types/common"
import GridMultipleSelectorInput from "../../../../components/controls/GridMultipleSelectorInput"
import useGridFilter, { CreateSelectorGridFilter } from "../../../../system/hooks/useGridFilter"
import DocumentTypesSelectorModal from "../../../Dictionaries/DocumentTypes/DocumentTypesSelectorModal"
import { AccessPointDataProvider } from "../../../../Services/DataProviders/AccessPointDataProvider"
import { StoreDataProvider } from "../../../../Services/DataProviders/StoreDataProvider"
import { ContractorDataProvider } from "../../../../Services/DataProviders/ContractorDataProvider"
import { DocumentTypesDictionaryData } from "../../../Dictionaries/DocumentTypes/DocumentTypesGrid"
import renderGlobalAlert from "../../../../system/hooks/useGlobalAlert"
import { MessageModalWindow } from "../../../../components/modalWindows/MessageModalWindow"
import { Space, Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';

const userName = () => {
    return JSON.parse(localStorage.getItem('TokenData') as string)?.payload.name;
}

const export1C = () => {
    return JSON.parse(localStorage.getItem(`${userName()}_export1C`) as string);
}

interface IMessageModalProps {
    show: boolean;
    data: IDataType[] | null;
}

interface IDataType {
    name: string;
    url: string;
}

export const Export1CView = (props) => {
    const tabContext = useTabsContext();
    const appContext = useAppContext();

    const export1CLocalStorage = export1C();

    const export1CDataProvider = new Export1CDataProvider(appContext.coreApiService);
    const accessPointDataProvider = new AccessPointDataProvider(appContext.coreApiService);
    const storeDataProvider = new StoreDataProvider(appContext.coreApiService);
    const contractorDataProvider = new ContractorDataProvider(appContext.coreApiService)

    const ExportDirectoryGridFilter: IGridFilter = {
        numberPerPage: 15,
        pageNumber: 1,
        columnFilters: [
            {
                name: "deleted",
                operator: "Eq",
                value: false,
            },
            {
                name: "protocol",
                operator: "Eq",
                value: "File",
            }
        ]
    };

    const [gridFilter, dispatchGridFilter] = useGridFilter(CreateSelectorGridFilter);
    const [gridFilterExportDirectory, dispatchGridFilterExportDirectory] = useGridFilter(ExportDirectoryGridFilter);

    // Период
    const DefaultDatePeriod = { startDate: DateTime.now().plus({ days: -7 }), endDate: DateTime.now() } as IDatePeriod;
    const [datePeriod, setDatePeriod] = useState<IDatePeriod>(DefaultDatePeriod);

    // Точность результата (количество знаков после запятой)
    const [scaleResult, setScaleResult] = useState<IOption>({displayName: '2', value: 2} as IOption);
    const defaultScaleResultOptions = [
        {displayName: '2', value: 2},
        {displayName: '3', value: 3},
        {displayName: '4', value: 4}
    ] as IOption[];

    // Точка доступа
    const [exportDirectory, setExportDirectory] = useState<IEntitySimpleDTO>();
    // Типы документов
    const [documentTypes, setDocumentTypes] = useState<IEntitySimpleDTO[]>([]);
    // Склады
    const [stores, setStores] = useState<IEntitySimpleDTO[]>([]);
    // Контрагенты
    const [contractors, setContractors] = useState<IEntitySimpleDTO[]>([]);
    // Контрагенты, для которых разрешено создание счет-фактуры
    const [contractorsShetFactura, setContractorsShetFactura] = useState<IEntitySimpleDTO[]>([]);
    
    const [showTable, setShowTable] = useState<IMessageModalProps>({ show: false, data: null });

    const columns = [
        {
            title: 'Название файла',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Ссылка',
            key: 'action',
            render: (_, record) => (
                <button
                    onClick={() => window.open(record.url, '_blank')}
                    style={{
                    padding: '8px 8px',
                    backgroundColor: '#006699',
                    fill: '#ffffff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',  
                    }}
                >
                    Скачать
                </button>
            ),
        },
    ];

    const [data, setData] = useState<IExport1CViewDto>({
        exportDirectory: '',
        dateFrom: datePeriod.startDate,
        dateTo: datePeriod.endDate,
        documentTypes: [],
        stores: [],
        contractors: [],
        isDOS: false,
        isMinIO: false,
        exportCashSessionDateClose: false,
        unloadQuantity: false,
        groupNds: false,
        groupSupplier: false,
        layoutGroups: false,
        cashSessionMove: false,
        paymentType: false,
        gtd: false,
        paymentTypeGroups: false,
        offBalanceGroups: false,
        codeNameUnitGroups: false,
        storeGroup: false,
        invoiceNumberGroups: false,
        chequeGroup: false,
        splitActReturn: false,
        scaleResult: scaleResult.value,
        contractorsShetFactura: []
    });

    useEffect(() => {
        exportDirectory?.idGlobal && accessPointDataProvider.getById(exportDirectory?.idGlobal, e => {
            setData({...data, exportDirectory: e.connectionString});
        })
    }, [exportDirectory]);

    useEffect(() => {
        if (export1CLocalStorage) {
            // Типы документов
            (export1CLocalStorage.documentTypes.length !== 0) && setDocumentTypes(DocumentTypesDictionaryData.filter(item => export1CLocalStorage.documentTypes.map(String).includes(item.idGlobal)).map(({ idGlobal, displayName }) => ({ idGlobal, displayName })));
            // Склады
            (export1CLocalStorage.stores.length !== 0) && fetchMultipleSelector(export1CLocalStorage.stores, storeDataProvider, (stores) => setStores(stores));
            // Контрагенты
            (export1CLocalStorage.contractors.length !== 0) && fetchMultipleSelector(export1CLocalStorage.contractors, contractorDataProvider, (contractors) => setContractors(contractors));
            // Контрагенты
            (export1CLocalStorage.contractorsShetFactura.length !== 0) && fetchMultipleSelector(export1CLocalStorage.contractorsShetFactura, contractorDataProvider, (contractorsShetFactura) => setContractorsShetFactura(contractorsShetFactura));
            // Точность результата (количество знаков после запятой)
            export1CLocalStorage.scaleResult && setScaleResult({displayName: `${export1CLocalStorage.scaleResult}`, value: export1CLocalStorage.scaleResult});
            // Период 
            (export1CLocalStorage.dateFrom && export1CLocalStorage.dateTo) && setDatePeriod({startDate: DateTime.fromJSDate(new Date(export1CLocalStorage.dateFrom)), endDate: DateTime.fromJSDate(new Date(export1CLocalStorage.dateTo))});

            setData({
                exportDirectory: export1CLocalStorage.exportDirectory,
                dateFrom: export1CLocalStorage.dateFrom,
                dateTo: export1CLocalStorage.dateTo,
                documentTypes: export1CLocalStorage.documentTypes,
                stores: export1CLocalStorage.stores,
                contractors: export1CLocalStorage.contractors,
                isDOS: export1CLocalStorage.isDOS,
                isMinIO: export1CLocalStorage.isMinIO,
                exportCashSessionDateClose: export1CLocalStorage.exportCashSessionDateClose,
                unloadQuantity: export1CLocalStorage.unloadQuantity,
                groupNds: export1CLocalStorage.groupNds,
                groupSupplier: export1CLocalStorage.groupSupplier,
                layoutGroups: export1CLocalStorage.layoutGroups,
                cashSessionMove: export1CLocalStorage.cashSessionMove,
                paymentType: export1CLocalStorage.paymentType,
                gtd: export1CLocalStorage.gtd,
                paymentTypeGroups: export1CLocalStorage.paymentTypeGroups,
                offBalanceGroups: export1CLocalStorage.offBalanceGroups,
                codeNameUnitGroups: export1CLocalStorage.codeNameUnitGroups,
                storeGroup: export1CLocalStorage.storeGroup,
                invoiceNumberGroups: export1CLocalStorage.invoiceNumberGroups,
                chequeGroup: export1CLocalStorage.chequeGroup,
                splitActReturn: export1CLocalStorage.splitActReturn,
                scaleResult: export1CLocalStorage.scaleResult,
                contractorsShetFactura: export1CLocalStorage.contractorsShetFactura
            });
        }
    }, []);

    function fetchMultipleSelector(
        idGlobalArray: string[],
        dataProvider: { getById: (id: string, callback: (data: any) => void) => void },
        callback: (result: Array<{ idGlobal: string; displayName: string }>) => void
    ) {
        if (!idGlobalArray || idGlobalArray.length === 0) {
            callback([]);
            return;
        }

        const results: Array<{ idGlobal: string; displayName: string }> = [];
        let completedRequests = 0;

        idGlobalArray.forEach((id) => {
            dataProvider.getById(id, (e) => {
                results.push({ idGlobal: id, displayName: e.name });
                completedRequests++;

                if (completedRequests === idGlobalArray.length) {
                    callback(results);
                }
            });
        });
    }

    return (
        <BaseDocumentCreator
            save={{
                title: 'Выгрузить',
                onClick: () => {
                    export1CDataProvider.export(data, (result) => {
                        try {
                            console.log(result)
                            localStorage.setItem(`${userName()}_export1C`, JSON.stringify(data));

                            const filesList: IDataType[] = Object.entries(result).map(([fileName, url]) => ({
                                name: fileName as string,
                                url: url as string, 
                            }));
                            
                            setShowTable({
                                show: true,
                                data: filesList
                            });
                        } catch {
                            renderGlobalAlert({
                                variant: "error",
                                title: "Превышено максимальное количество",
                                statusCode: 400,
                            });
                        }
                    });
                }
            }}
            cancel={{
                title: 'Закрыть',
                onClick: () => tabContext.closeCurrent()
            }}
        >
            <GridSelectorInput
                inline
                label={"Точка доступа"}
                id={"exportDirectory"}
                selectorModalJsx={AccessPointSelectorModal}
                selectedEntity={exportDirectory}
                gridFilter={gridFilterExportDirectory}
                onSelect={(entity) => {
                    setExportDirectory(entity);
                    setData({ ...data, exportDirectory: entity?.idGlobal });
                }}
                onClear={() => {
                    setExportDirectory(undefined);
                    setData({ ...data, exportDirectory: '' })
                }}
            />
            <DatePeriodPanel
                inline
                datePeriod={datePeriod}
                label={'Период'}
                onDatePeriodChange={(date: IDatePeriod) => {
                    setDatePeriod(date);
                    setData({ ...data, dateFrom: date.startDate, dateTo: date.endDate });
                }}
            />
            <GridMultipleSelectorInput 
                selectedEntity={documentTypes?.[0]}
                selectedEntities={documentTypes}
                gridFilter={gridFilter}
                id={"documentTypes"}
                switchOnchange
                selectorModalJsx={DocumentTypesSelectorModal}
                label={"Типы документов"}
                onSelect={(entities: IEntitySimpleDTO[]) => {
                    setDocumentTypes(entities);
                    setData({ ...data, documentTypes: entities.map(element => Number(element.idGlobal))});
                }}
                onClear={() => {
                    setDocumentTypes([]);
                    setData({ ...data, documentTypes: []});
                }}
                treeViewCheckDirectoryType={'pharmacy'}
                activateGroupProcessing
                viewMode
                applyUserFilter
            />
            <GridMultipleSelectorInput
                selectedEntity={stores?.[0]}
                selectedEntities={stores}
                gridFilter={gridFilter}
                id={"stores"}
                switchOnchange
                selectorModalJsx={StoreSelectorModal}
                label={"Склады"}
                onSelect={(entities: IEntitySimpleDTO[]) => {
                    setStores(entities);
                    setData({ ...data, stores: entities.map(element => element.idGlobal)});
                }}
                onClear={() => {
                    setStores([]);
                    setData({ ...data, stores: []});
                }}
                treeViewCheckDirectoryType={'pharmacy'}
                activateGroupProcessing
                viewMode
                applyUserFilter
            />
            <GridMultipleSelectorInput
                selectedEntity={contractors?.[0]}
                selectedEntities={contractors}
                gridFilter={gridFilter}
                id={"contractors"}
                switchOnchange
                selectorModalJsx={ContractorSelectorModal}
                label={"Контрагенты"}
                onSelect={(entities: IEntitySimpleDTO[]) => {
                    setContractors(entities);
                    setData({ ...data, contractors: entities.map(element => element.idGlobal)});
                }}
                onClear={() => {
                    setContractors([]);
                    setData({ ...data, contractors: []});
                }}
                treeViewCheckDirectoryType={'pharmacy'}
                activateGroupProcessing
                viewMode
                applyUserFilter
            />

            <Accordion 
                opened={false} 
                caption={'Дополнительно'} 
                id={`addition-${uuidv4()}`}
            >
                <FlexRow>
                    <FlexColumn>
                        <CheckBox
                            id="isDOS"
                            label={'Выгружать в кодировке DOS'}
                            defaultChecked={data.isDOS}
                            onChanged={(checked) => setData({ ...data, isDOS: checked })}
                        />
                        <CheckBox
                            id="isMinIO"
                            label={'Выгружать в хранилище файлов'}
                            defaultChecked={data.isMinIO}
                            onChanged={(checked) => setData({ ...data, isMinIO: checked })}
                        />
                        <CheckBox
                            id="exportCashSessionDateClose"
                            label={'При экспорте кассовых смен дата документа = дата закрытия смены'}
                            defaultChecked={data.exportCashSessionDateClose}
                            onChanged={(checked) => setData({ ...data, exportCashSessionDateClose: checked })}
                        />
                        <CheckBox
                            id="unloadQuantity"
                            label={'Выгружать количество'}
                            defaultChecked={data.unloadQuantity}
                            onChanged={(checked) => setData({ ...data, unloadQuantity: checked })}
                        />
                        <CheckBox
                            id="groupNds"
                            label={'Разбивать по ставкам НДС'}
                            defaultChecked={data.groupNds}
                            onChanged={(checked) => setData({ ...data, groupNds: checked })}
                        />
                        <CheckBox
                            id="groupSupplier"
                            label={'Разбивать по поставщикам'}
                            defaultChecked={data.groupSupplier}
                            onChanged={(checked) => setData({ ...data, groupSupplier: checked })}
                        />
                        <CheckBox
                            id="layoutGroups"
                            label={'Разбивать по группам контрагентов'}
                            defaultChecked={data.layoutGroups}
                            onChanged={(checked) => setData({ ...data, layoutGroups: checked })}
                        />
                        <CheckBox
                            id="cashSessionMove"
                            label={'Выгружать расходные документы по движению партии'}
                            defaultChecked={data.cashSessionMove}
                            onChanged={(checked) => setData({ ...data, cashSessionMove: checked })}
                        />
                        <CheckBox
                            id="paymentType"
                            label={'Выгружать суммы по безналичному типу оплаты для расходных накладных и кассовых смен'}
                            defaultChecked={data.paymentType}
                            onChanged={(checked) => setData({ ...data, paymentType: checked })}
                        />
                        <Select
                            inline
                            label={"Точность результата (количество знаков после запятой)"}
                            value={scaleResult}
                            onSelect={(option) => {
                                setScaleResult(option);
                                setData({ ...data, scaleResult: option.value });
                            }}
                            defaultOption={defaultScaleResultOptions[0]}
                            options={defaultScaleResultOptions}
                        />
                    </FlexColumn>
                    <FlexColumn>
                        <CheckBox
                            id="gtd"
                            label={'Выгружать ПН с разбивкой по ГТД'}
                            defaultChecked={data.gtd}
                            onChanged={(checked) => setData({ ...data, gtd: checked })}
                        />
                        <CheckBox
                            id="paymentTypeGroups"
                            label={'Разбивать по типам оплаты'}
                            defaultChecked={data.paymentTypeGroups}
                            onChanged={(checked) => setData({ ...data, paymentTypeGroups: checked })}
                        />
                        <CheckBox
                            id="offBalanceGroups"
                            label={'Разбивать по признаку "Баланс/Забаланс"'}
                            defaultChecked={data.offBalanceGroups}
                            onChanged={(checked) => setData({ ...data, offBalanceGroups: checked })}
                        />
                        <CheckBox
                            id="codeNameUnitGroups"
                            label={'Разбивать по Коду/Названию/Ед.измерения товара'}
                            defaultChecked={data.codeNameUnitGroups}
                            onChanged={(checked) => setData({ ...data, codeNameUnitGroups: checked })}
                        />
                        <CheckBox
                            id="storeGroup"
                            label={'Разбивать по складам'}
                            defaultChecked={data.storeGroup}
                            onChanged={(checked) => setData({ ...data, storeGroup: checked })}
                        />
                        <CheckBox
                            id="invoiceNumberGroups"
                            label={'Разбивать по номеру/дате счет-фактуры'}
                            defaultChecked={data.invoiceNumberGroups}
                            onChanged={(checked) => setData({ ...data, invoiceNumberGroups: checked })}
                        />
                        <CheckBox
                            id="chequeGroup"
                            label={'Разбивать по чекам (тип документов: Кассовые чеки)'}
                            defaultChecked={data.chequeGroup}
                            onChanged={(checked) => setData({ ...data, chequeGroup: checked })}
                        />
                        <CheckBox
                            id="splitActReturn"
                            label={'Разбивать акты возврата поставщику по номеру/дате счёта фактуры'}
                            defaultChecked={data.splitActReturn}
                            onChanged={(checked) => setData({ ...data, splitActReturn: checked })}
                        />
                        <GridMultipleSelectorInput
                            selectedEntity={contractorsShetFactura?.[0]}
                            selectedEntities={contractorsShetFactura}
                            gridFilter={gridFilter}
                            id={"contractorsShetFactura"}
                            switchOnchange
                            selectorModalJsx={ContractorSelectorModal}
                            label={"Контрагенты, для которых разрешено создание счет-фактуры"}
                            onSelect={(entities: IEntitySimpleDTO[]) => {
                                setContractorsShetFactura(entities);
                                setData({ ...data, contractorsShetFactura: entities.map(element => element.idGlobal)});
                            }}
                            onClear={() => {
                                setContractorsShetFactura([]);
                                setData({ ...data, contractorsShetFactura: []});
                            }}
                            treeViewCheckDirectoryType={'pharmacy'}
                            activateGroupProcessing
                            viewMode
                            applyUserFilter
                        />
                    </FlexColumn>
                </FlexRow>
            </Accordion>      
            {showTable.show && (
                <Table
                    dataSource={showTable.data as IDataType[]}
                    columns={columns}
                    pagination={false}
                />
            )}            
        </BaseDocumentCreator>
    )
}